import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";

import "./RightSideMenu.css";

const RightSideMenu = () => {
  const [open, setOpen] = useState(false);
  const [activeSub, setActiveSub] = useState(null);
  const [showMenu, setShowMenu] = useState(false);

  useEffect(() => {
    const container = document.querySelector(".scroll-container");
    const about = document.getElementById("about");

    if (!container || !about) return;

    const handleScroll = () => {
      const aboutTop = about.offsetTop;
      const scrollPosition = container.scrollTop;

      if (scrollPosition >= aboutTop - 10) {
        setShowMenu(true);
      } else {
        setShowMenu(false);
        setOpen(false);
      }
    };

    container.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => container.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleSubMenu = (menu) => {
    setActiveSub(prev => (prev === menu ? null : menu));
  };

  const closeMenu = () => {
    setOpen(false);
    setActiveSub(null);
  };

  return (
    <>
      {showMenu && !open && (
        <div className="hamburger" onClick={() => setOpen(true)}>
          <i class="bi bi-list"></i>
        </div>
      )}

      <div
        className={`overlay ${open ? "show" : ""}`}
        onClick={closeMenu}
      ></div>

      <div className={`side-menu ${open ? "open" : ""}`}>
        <div className="close-btn" onClick={closeMenu}>×</div>

        <ul>

          <li>
            <Link to="/about" onClick={closeMenu}>About</Link>
          </li>

          {/* Techno Echo */}
          <li className="has-sub">
            <div onClick={() => toggleSubMenu("education")}>
              <span>Techno Echo</span>
              <span className={`arrow ${activeSub === "education" ? "rotate" : ""}`}>
                <i className="bi bi-caret-right-fill"></i>
              </span>
            </div>

            <ul className={`submenu ${activeSub === "education" ? "open" : ""}`}>
              <li><a href="/pdf/techno-echo/TECHNO-ECHO_FEB_2025_VOL_2_ISSUE_1.pdf" target="_blank" onClick={closeMenu}>Vol.2</a></li>
              <li><a href="/pdf/techno-echo/TECHNO-ECHO-july-2024_Vol.1_Issue1.pdf" target="_blank" onClick={closeMenu}>Vol.1</a></li>
            </ul>
          </li>

          {/* Healthcare */}
          <li className="has-sub">
            <div onClick={() => toggleSubMenu("healthcare")}>
              <span>Initiatives</span>
              <span className={`arrow ${activeSub === "healthcare" ? "rotate" : ""}`}>
                <i className="bi bi-caret-right-fill"></i>
              </span>
            </div>

            <ul className={`submenu ${activeSub === "healthcare" ? "open" : ""}`}>
              <li><Link to="/education" onClick={closeMenu}>Education</Link></li>
              <li><Link to="/sports" onClick={closeMenu}>Sports</Link></li>
              <li><Link to="/hospitality" onClick={closeMenu}>Hospitality</Link></li>
              <li><Link to="/media" onClick={closeMenu}>Media</Link></li>
              <li><Link to="/healthcare" onClick={closeMenu}>Healthcare</Link></li>
            </ul>
          </li>

          {/* Sports */}
          <li className="has-sub">
            <div onClick={() => toggleSubMenu("sports")}>
              <span>Highlights</span>
              <span className={`arrow ${activeSub === "sports" ? "rotate" : ""}`}>
                <i className="bi bi-caret-right-fill"></i>
              </span>
            </div>

            <ul className={`submenu ${activeSub === "sports" ? "open" : ""}`}>
              <li><Link to="/gallery" onClick={closeMenu}>Gallery</Link></li>
              <li><Link to="/event" onClick={closeMenu}>Events</Link></li>
              <li><Link to="/newsclippings" onClick={closeMenu}>News Clippings</Link></li>
            </ul>
          </li>


          <li>
            <Link to="#" onClick={closeMenu}>Contact</Link>
          </li>
          <li>
            <a href="https://careers.technoindiagroup.in/" onClick={closeMenu}>Career</a>
          </li>

        </ul>
      </div>
    </>
  );
};

export default RightSideMenu;